export default function CountryCard({ country, flag, onClick }) {
    return (
      <button
        onClick={onClick}
        className="flex items-center justify-between p-2 bg-white rounded-lg shadow-custom transition-shadow gap-5"
      >
        <span className="text-lg">{country}</span>
        <img loading={"lazy"} src={flag || "/placeholder.svg"} alt={`${country} flag`} className="w-[96px] h-[72px] object-cover rounded-md border border-slate-400" />
      </button>
    ) 
  } 
